import React, { useEffect, useState } from 'react';
import useDataPermission from '../../hooks/useDataPermission';
import { Box, Chip, FilledInput, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import { usePermissionStore } from '../../store/permission.store';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import { useAuth } from '../../store/auth.store';
import { HexColorPicker } from "react-colorful";
import Grid from '@mui/material/Grid2';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import ClearIcon from '@mui/icons-material/Clear';
import { useTour } from '../../provider/TourGuide';

const colors = ['#F58E08','#FC6C50','#F14483','#AB3CF0','#418CDD','#3149E5','#269E36','#1E676E','#546D79']

const Tags = () => {
    const {data} = useDataPermission()
    const { setChoosedPermission, choosedPermission, text, setText, openEdit, setOpenEdit,color, setColor} = usePermissionStore()
    const [openPicker, setOpenPicker] = useState(false)
    const {user} = useAuth()
    const { bussniesNumber } = useTour()

    const handleOpenEdit = (item: IPermission) => {
        if (choosedPermission?.id === item.id) {
          setChoosedPermission(null);
          setOpenEdit(false);
          return;
        }
      
        setColor(item.color);
        setChoosedPermission(item);
        setText(item.title);
        setOpenEdit(true);
    };

    const handleNewOne = () => {
        setOpenEdit(true)
        setText('')
        setColor('#000000')
        setChoosedPermission({
            "id": 99999999999,
            "isEditable": true,
            "title": "",
            "color": "#F58E08",
            "permissionDetaileds": [
                {
                    "id": 99999999999,
                    "isArchitecture": false,
                    "isOrderable": false,
                    "isOrderEditable": false,
                    "isServiceable": false,
                    "isServiceEditable": false,
                    "isOrdersView": false,
                    "isServiceView": false,
                    "isDeliveryView": false,
                    "isAccounting": false
                }
            ]
        })
    }

    const handleCorrectName = (): boolean => {
        const trimmed = text.trim();
        return trimmed.length > 0 && !data?.some(item => item.title === trimmed);
    }

    useEffect(() => {
        const check = data?.filter((x) => x.isEditable === true);
        if(bussniesNumber !== 2 && bussniesNumber !== 0) {
            setChoosedPermission(null)
            setOpenEdit(false)
        }

        if(check?.length === 0 && bussniesNumber !== 2){
            handleNewOne()
        }
    },[data])

    const check = data?.filter((x) => x.isEditable === true);
    const isDisable = check?.length === 0 && bussniesNumber !== 2
    return (
        <Box>
            <Grid container sx={{alignItems:'center'}} spacing={'5px'}>
                <Grid>
                {!isDisable &&
                    <IconButton onClick={() => handleNewOne()}>
                        <AddCircleOutlineRoundedIcon sx={{color:'#2F4B6C', fontSize:'30px'}}/>
                    </IconButton>
                }

                </Grid>
                    {bussniesNumber === 2 ?
                        <>
                        <Grid>
                            <Chip
                                label={'אחמ"ש'}
                                variant="outlined"
                                clickable
                                style={{color: '#418CDD', borderColor:'#418CDD', marginRight:'5px'}} 
                            />
                        </Grid>
                        <Grid>
                            <Chip
                                    label={'מנהל רכש'}
                                    variant={'outlined'} 
                                    style={{color: '#269E36', borderColor:'#269E36', marginRight:'5px'}} 
                            />
                        </Grid>
                        </>
                    :
                        <>
                        {data?.map((item) => {
                                if(item.isEditable) {
                                    return (
                                        <Grid  key={item.id}>
                                            <Chip
                                                label={item?.title}
                                                variant="outlined"
                                                onClick={() => handleOpenEdit(item)}
                                                clickable
                                                sx={{
                                                    fontWeight: 700,
                                                    fontSize: '12px',
                                                    lineHeight: '19px',
                                                    bgcolor: choosedPermission?.id === item.id ? item.color : 'transparent',
                                                    color: choosedPermission?.id === item.id ? 'white' : item.color,
                                                    border: choosedPermission?.id === item.id ? 'transparent' : `1px solid ${item.color}`,
                                                    '&.MuiChip-clickable:hover': {
                                                        bgcolor: item.color,
                                                        color: 'white',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                    )
                                }
                            })}
                        </>
                    }
              
            </Grid>
        
            {openEdit &&
                <Box sx={{padding:'0 10px', mt: isDisable ? '10px' : '25px'}}>
                    <Typography fontWeight={700} fontSize={'15px'} lineHeight={'21px'} color='#154D72'>
                    בחירת שם התגית
                    </Typography>
                    <TextField
                        sx={{
                            marginTop:'10px',
                        }}
                        variant="outlined"
                        type="text"
                        fullWidth
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="create new item"
                                        // onClick={createNewOne}
                                        edge="end"
                                    >
                                        {handleCorrectName() ?
                                            <DoneRoundedIcon sx={{color:"#154D72"}}/>
                                        :
                                            <ClearIcon sx={{color:"#154D72"}}/>
                                        }
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Typography fontWeight={700} fontSize={'15px'} lineHeight={'21px'} color='#154D72' sx={{mt:'30px'}}>
                    בחירת צבע התגית
                    </Typography>
                    <Box sx={{display:'flex', gap:'5px', mt:'10px'}}>
       
                        {colors?.map((color) =>
                            <Box
                               onClick={() => setColor(color)}
                               sx={{
                                   cursor:'pointer',
                                   width: 30,      
                                   height: 30,      
                                   backgroundColor: `${color}`,  
                                   borderRadius: '50%',  
                                   display: 'inline-block',
                               }}
                           />
                        )}
                            <IconButton
                               onClick={() => setOpenPicker(!openPicker)}
                               sx={{
                                   width: 30,      
                                   height: 30,      
                                   borderRadius: '50%',  
                                   display: 'flex',
                                   border:'1px solid #8EA6B2',
                                   justifyContent:'center',
                                   alignItems:'center',
                                   bgcolor:color
                               }}
                           >
                                <img src={`${process.env.REACT_APP_MEDIA}/editIcon.svg`} width={15} height={15}/>
                            </IconButton>
                    </Box>
                    {openPicker &&
                    <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center', padding:'10px'}}>
                        <Box sx={{position:'relative'}}>
                            <IconButton sx={{position:'absolute', right:-50}} onClick={() => setOpenPicker(false)}>
                                <CloseTwoToneIcon sx={{color:'#436F7C'}}/>
                            </IconButton>
                            <Box sx={{mt:'20px'}}>
                                <HexColorPicker color={color} onChange={setColor} />
                            </Box>
                        </Box>
                    </Box>
                    }
                </Box>
            }
        </Box>
    );
};

export default Tags;